import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { COLORS } from "../../config/theme/baseTheme";
import {
  deliveryProofSectionStyles,
  geocodedAddressStyles,
  headingContainerStyles,
  modalStyles,
  orderStatusTagVariants,
  tabularSectionItemContentStyles,
  tagStyles,
  timelineStyles,
  useSideModalCloseOpenStyles,
} from "SharedComponent/styles/sharedStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    titleContainer: {
      ...headingContainerStyles(),
      "& .tagContainer": {
        marginLeft: theme.spacing(1),
        "& .tag": {
          ...tagStyles(theme).base,
          ...orderStatusTagVariants,
          "&.OCEAN_GREEN": {
            color: COLORS.OCEAN_GREEN,
            backgroundColor: COLORS.WHITE,
            border: "solid",
            borderWidth: "1px",
            borderColor: COLORS.OCEAN_GREEN,
          },
          "&.CORAL_PINK": {
            color: COLORS.CORAL_PINK,
            backgroundColor: COLORS.WHITE,
            border: "solid",
            borderWidth: "1px",
            borderColor: COLORS.CORAL_PINK,
          },
          "&.ALERT_ORANGE": {
            color: COLORS.ALERT_ORANGE,
            backgroundColor: COLORS.WHITE,
            border: "solid",
            borderWidth: "1px",
            borderColor: COLORS.ALERT_ORANGE,
          },
          "&.AVATAR_OCEAN": {
            color: COLORS.AVATAR_OCEAN,
            backgroundColor: COLORS.WHITE,
            border: "solid",
            borderWidth: "1px",
            borderColor: COLORS.AVATAR_OCEAN,
          },
          "&.DARK_GOLD_ORANGE": {
            color: COLORS.DARK_GOLD_ORANGE,
            backgroundColor: COLORS.WHITE,
            border: "solid",
            borderWidth: "1px",
            borderColor: COLORS.DARK_GOLD_ORANGE,
          },
        },
      },
      "& .editIcon": {
        paddingLeft: theme.spacing(1.5),
        "& .icon": {
          cursor: "pointer",
          verticalAlign: "middle",
        },
      },
    },
    contentContainer: {
      flexDirection: "column",
      flexWrap: "nowrap",
      "& .geocodedAddress": {
        paddingBottom: theme.spacing(2),
        ...geocodedAddressStyles(theme),
      },
      "& .detailsHeader": {
        flexDirection: "column",
        backgroundColor: COLORS.TRANSPARENT_BLUE,
        padding: "18px 16px",
        borderRadius: theme.spacing(1),
        "& .detailsHeaderItem": {
          paddingBottom: theme.spacing(2),
          "& .title": {
            lineHeight: "17px",
            fontSize: 14,
            fontWeight: 600,
          },
          "& .editIcon": {
            display: "flex",
            justifyContent: "flex-end",
          },
          "& .subSection": {
            paddingTop: "16px",
            display: "flex",
          },
          "& .subSectionTitle": {
            fontSize: "14px",
            fontWeight: 600,
          },
          "& .subSectionContent": {
            fontSize: "14px",
            fontWeight: 500,
            paddingLeft: "8px",
          },
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .editAddress": {
            height: "18px",
            width: "18px",
            cursor: "pointer",
          },
          "& .headerItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& .contactItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& p": {
            lineHeight: "17px",
            fontSize: 14,
          },
          "& .name": {
            fontWeight: 600,
          },
          "&.geocodedAddress": {
            paddingBottom: "6px",
            ...geocodedAddressStyles(theme),
          },
          "& .contactMobile": {
            marginRight: theme.spacing(5),
          },
          "& .logo": {
            width: 24,
            height: 24,
          },
          "& .contact": {
            "& a": {
              lineHeight: "17px",
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "none",
              color: theme.palette.text.primary,
            },
            paddingLeft: theme.spacing(1),
            "&.mobile": {
              paddingLeft: theme.spacing(0.25),
            },
          },
        },
      },
      "& .contentHubAddress": {
        display: "flex",
        flexDirection: "column",
        "& .main": {
          display: "flex",
          flexDirection: "column",
        },
        "& .title": {
          lineHeight: "17px",
          fontSize: 14,
          fontWeight: 600,
        },
        "& .content": {
          paddingTop: "16px",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "20px",
        },
        "& .subSection": {
          paddingTop: "16px",
          display: "flex",
        },
        "& .subSectionTitle": {
          fontSize: "14px",
          fontWeight: 600,
        },
        "& .subSectionContent": {
          fontSize: "14px",
          fontWeight: 500,
          paddingLeft: "8px",
        },
        "& .detailsHeaderItem": {
          paddingBottom: theme.spacing(2),
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .editAddress": {
            height: "18px",
            width: "18px",
            cursor: "pointer",
          },
          "& .headerItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& .contactItemContainer": {
            alignItems: "center",
            flexWrap: "nowrap",
          },
          "& p": {
            lineHeight: "17px",
            fontSize: 14,
          },
          "& .name": {
            fontWeight: 600,
          },
          "&.geocodedAddress": {
            paddingBottom: "6px",
            "& .addressColItem": {
              alignSelf: "flex-start",
            },
            "& .geoLocAddressContainer": {
              cursor: "pointer",
              "& .address": {
                fontSize: 12,
                fontWeight: 600,
                color: theme.palette.primary.main,
                lineHeight: "14px",
                paddingRight: 3,
              },
              "& .addressLogo": {
                width: 12,
                height: 12,
                transform: "rotate(0deg)",
                transition: "transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                "&.open": {
                  transform: "rotate(180deg)",
                },
              },
            },
            "& .addressMapContainer": {
              height: 243,
              border: `1px solid ${COLORS.SILVER}`,
              borderRadius: theme.spacing(1),
              marginTop: theme.spacing(1),
              backgroundColor: COLORS.SILVER,
            },
          },
          "& .contactMobile": {
            marginRight: theme.spacing(5),
          },
          "& .logo": {
            width: 24,
            height: 24,
          },
          "& .contact": {
            "& a": {
              lineHeight: "17px",
              fontSize: 14,
              fontWeight: 600,
              textDecoration: "none",
              color: theme.palette.text.primary,
            },
            paddingLeft: theme.spacing(1),
            "&.mobile": {
              paddingLeft: theme.spacing(0.25),
            },
          },
        },
      },
      "& .detailsContent": {
        flexDirection: "column",
        flexWrap: "nowrap",
        padding: theme.spacing(3, 1, 2, 1),
        "& .contentRow": {
          paddingBottom: theme.spacing(3),
          "&.hubDetails": {
            paddingBottom: theme.spacing(1),
          },
          "&:last-child": {
            paddingBottom: 0,
          },
          "& .contentColumn": {
            flex: "2 0 0",
            "&:last-child": {
              flex: "1 0 0",
            },
            "& p": {
              fontSize: 14,
              lineHeight: "17px",
            },
            "& .label": {
              paddingBottom: theme.spacing(1),
            },
            "& .content": {
              fontWeight: 600,
            },
          },
          "& .columnDetails": {
            alignContent: "flex-end",
          },
          "& .endColumnDetails": {
            display: "flex",
            justifyContent: "flex-end",
          },
        },
      },
      "& .sellerDetails": {
        paddingTop: theme.spacing(1.75),
        "& .detailsHeader": {
          backgroundColor: theme.palette.secondary.main,
        },
      },
      ...deliveryProofSectionStyles(theme),
      "& .consignmentHistory": {
        paddingBottom: theme.spacing(1),
      },
      "& .tabularSection": {
        paddingBottom: theme.spacing(1),
        "&:last-child": {
          paddingBottom: 0,
        },
        "&.crates": {
          "& .itemsContainer .item .itemContainer .itemColumn.item1 p": {
            fontWeight: 600,
          },
          "& .itemsContainer .item .itemContainer .itemColumn.item1 .header p": {
            fontWeight: 500,
          },
          "& .crateBarcode": {
            width: 80,
            height: 20,
            marginLeft: theme.spacing(3),
          },
          "& .crateStageLocationIcon": {
            width: 16,
            height: 16,
            marginRight: theme.spacing(1),
          },
          "& .crateDetails": {
            fontSize: "14px",
          },
        },
        "& .itemDiv": {
          padding: theme.spacing(0),
          "& .content": {
            ...tabularSectionItemContentStyles(theme),
          },
        },
      },
    },
    accordionSummary: {
      "& .header": {
        fontSize: 14,
        fontWeight: 600,
        paddingBottom: theme.spacing(0.5),
        "&:last-child": {
          paddingBottom: 0,
        },
        "& .smallHeading": {
          fontSize: 12,
        },
        "& .itemStatusVerified": {
          fontSize: 12,
          color: "#319E60",
          marginLeft: "8px",
        },
        "& .itemStatusUnverified": {
          fontSize: 12,
          color: "#CF9E36",
          marginLeft: "8px",
        },
      },
      "& .content": {
        flexGrow: 1,
      },
    },
    ...timelineStyles(theme),
    verifiedCrate: {
      fontSize: "14px",
      color: "#319E60",
    },
    unverifiedCrate: {
      fontSize: "14px",
      color: "#CF9E36",
    },
    dialogPaperPropsRoot: {
      ...modalStyles().dialogPaper,
    },
    verticalDiv: {
      color: "#0E5AA7",
      height: "16px",
      background: "#0E5AA7",
      width: "2px",
      margin: "2px 16px 0px 16px",
    },
    horizontalDiv: {
      borderBottom: "1px solid #E6E6E6",
      marginBottom: "16px",
    },
    ...useSideModalCloseOpenStyles(),
    cratesOrderDetailsSummaryDiv: {
      margin: "16px 0px 16px 0px",
      padding: "0px 8px 0px 8px",
    },
    cratesOrderDetailsHeadingSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "14px",
      fontWeight: 400,
      wordBreak: "break-all",
    },
    cratesOrderDetailsValueSpanStyle: {
      margin: "8px 0px 0px 0px",
      padding: 0,
      fontSize: "14px",
      fontWeight: 600,
    },
    cratesOrderDetailsVerifiedSpanStyle: {
      margin: 0,
      padding: "4px",
      fontSize: "12px",
      fontWeight: 500,
      color: COLORS.OCEAN_GREEN,
      border: "1px solid",
      borderColor: COLORS.OCEAN_GREEN,
      borderRadius: "4px",
    },
    cratesOrderDetailsUnVerifiedSpanStyle: {
      margin: 0,
      padding: "4px",
      fontSize: "12px",
      fontWeight: 500,
      color: COLORS.DUSTY_GRAY,
      border: "1px solid",
      borderColor: COLORS.DUSTY_GRAY,
      borderRadius: "4px",
    },
    cratesOrderDetailsIconStyle: {
      margin: "0px 0px 0px 0px",
      padding: "0px 0px 0px 0px",
      width: "18px",
      height: "18px",
      cursor: "pointer",
      transform: "rotate(-90deg)",
    },
    detailsItemContent: {
      margin: "0px 0px 16px 0px",
      padding: "16px",
      backgroundColor: COLORS.MINE_SHAFT_LIGHT,
      borderRadius: "8px",
    },
    detailsItemContentDivStyle: {
      margin: "0px 0px 8px 0px",
      padding: 0,
    },
    detailsItemContentLabelStyle: {
      fontSize: 14,
      lineHeight: "17px",
      fontWeight: 400,
    },
    detailsItemContentValueStyle: {
      fontSize: 14,
      lineHeight: "17px",
      fontWeight: 600,
    },
    cratesOrderDetailsIssueFoundspanStyle: {
      margin: "0px 0px 8px 0px",
      padding: 0,
      fontSize: "14px",
      fontWeight: 700,
    },
    issueItemDetailsDiv: {
      margin: "auto",
    },
    issueDetailsMainCard: {
      margin: 0,
      padding: 0,
      boxShadow: "none",
    },
    issueItemDetailsCard: {
      width: "100%",
      margin: 0,
      padding: "16px 8px",
      boxShadow: "none",
      border: "1px solid",
      borderColor: COLORS.ALTO,
    },
    paddingLeftStyle: {
      padding: "0px 0px 0px 12px",
    },
    cratesOrderDetailsPartialVerifiedSpanStyle: {
      margin: 0,
      padding: "4px",
      fontSize: "10px",
      fontWeight: 400,
      color: COLORS.GREY_SCALE,
      border: "1px solid",
      borderColor: COLORS.EMPEROR,
      borderRadius: "4px",
    },
    closeButton: {
      top: "16px",
      color: COLORS.PRIMARY_MAIN,
      right: "24px",
      position: "absolute",
    },
    /**  */
    itemSummaryAccordianDetailsStyle: {
      margin: 0,
      padding: 0,
      display: "block",
    },
    itemSummaryHeaderGridItemStyle: {
      margin: 0,
      padding: "0px 0px 14px 0px",
      border: "none",
      borderBottom: "1px solid #E6E6E6",
    },
    itemSummaryHeaderContainerDivStyle: {
      margin: 0,
      padding: "14px 14px 0px 14px",
      width: "100%",
      height: "auto",
      border: "none",
    },
    itemSummarySunstitutedContainerDivStyle: {
      margin: "12px 0px 4px 0px",
      padding: "0px 14px 0px 14px",
      width: "100%",
      minHeight: "50px",
      border: "none",
      background: COLORS.SECONDARY_MAIN,
    },
    itemSummaryHeaderItemDivStyle: {
      margin: "auto",
      padding: 0,
    },
    itemSummaryHeaderItemValueDivStyle: {
      margin: "auto",
      padding: 0,
      textAlign: "center",
    },
    itemSummaryItemDetailValueDivStyle: {
      margin: "auto 0px",
      padding: "4px 0px 0px 0px",
    },
    itemSummaryHeadingValueSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "14px",
      fontWeight: 600,
    },
    itemSummaryHeadingResultSpanStyle: {
      margin: 0,
      padding: "0px 0px 4px",
      fontSize: "14px",
      fontWeight: 400,
    },
    itemSummarySubHeadingBoldSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "12px",
      fontWeight: 600,
    },
    itemSummarySubHeadingBoldUnderlineSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "12px",
      fontWeight: 600,
      textDecoration: "underline",
      cursor: "pointer",
    },
    itemSummarySubHeadingSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "12px",
      fontWeight: 400,
    },
    itemSummaryVerifiedCrate: {
      margin: 0,
      padding: 0,
      fontSize: "12px",
      fontWeight: 400,
      color: "#319E60",
    },
    itemSummaryUnverifiedCrate: {
      margin: 0,
      padding: 0,
      fontSize: "12px",
      fontWeight: 400,
      color: "#CF9E36",
    },
    //
    itemSummaryFooterMainContainerDivStyle: {
      margin: 0,
      padding: 0,
    },
    itemSummaryFooterMainItemDivStyle: {
      margin: 0,
      padding: "8px 16px 0px 16px",
      width: "100%",
      height: "36px",
      border: "none",
    },
    itemSummaryFooterMainItemDivLastChildStyle: {
      margin: 0,
      padding: "16px 16px 16px 16px",
      width: "100%",
      height: "52px",
    },
    borderTopStyle: {
      borderTop: "1px solid #E6E6E6",
    },
    itemSummaryFooterGridContainerStyle: {
      margin: "auto",
      padding: 0,
      width: "100%",
      height: "100%",
    },
    itemSummaryFooterLeftGridItemStyle: {
      margin: "auto",
      padding: 0,
      display: "flex",
      justifyContent: "flex-start",
    },
    itemSummaryFooterRightGridItemStyle: {
      margin: "auto",
      padding: 0,
      display: "flex",
      justifyContent: "flex-end",
    },
    itemSummaryFooterValueSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "14px",
      fontWeight: 500,
    },
    itemSummaryFooterValueBoldSpanStyle: {
      margin: 0,
      padding: 0,
      fontSize: "14px",
      fontWeight: 700,
    },
  })
);
